import { Card, CardBody, Col, Row } from "reactstrap";
import { Image } from "../../../AbstractElements";
import { dynamicImage } from "../../../Utils";
import CommonCardHeader from "../../CommonComponents/CommonCardHeader/CommonCardHeader";
import { ImageSizeTitle } from "../../../Constants/Constants";
import { ImageData, ImageSubTitle } from "../../../Data/UiKits/HelperClasses";

const ImageSize = () => {
  return (
    <Col xl="6">
      <Card className="height-equal">
        <CommonCardHeader title={ImageSizeTitle} span={ImageSubTitle} />
        <CardBody>
          <Row className="g-3">
            <Col xs="12">
              <div className="card-wrapper border rounded-3 h-100">
                <div className="gradient-border gap-3">{ImageData && ImageData.map((item, index) => <Image className={`img-${item.size} img-h-${item.size}`} src={dynamicImage(`blog/comment.jpg`)} alt="img-size" key={index} />)}</div>
              </div>
            </Col>
            <Col xs="12">
              <div className="card-wrapper border rounded-3 h-100">
                <div className="gradient-border gap-3">{ImageData && ImageData.map((item, index) => <Image className={`img-${item.size} img-h-${item.size} ${item.rounded}`} src={dynamicImage(`blog/comment.jpg`)} alt="img-size" key={index} />)}</div>
              </div>
            </Col>
          </Row>
        </CardBody>
      </Card>
    </Col>
  );
};
export default ImageSize;
